export const navigation = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  }, 
  {
    text: 'InTray',
    path: '/in-tray',
    icon: 'message'
  },
  {
    text: 'Scheme Details',
    path: '/reports',
    icon: 'doc'
  },
  {
    text: 'Members',
    path: '/members',
    icon: 'group'
  },
  {
    text: 'Claims',
    path: '/claims',
    icon: 'card'
  },
  // {
  //   text: 'Write to Britam',
  //   path: '/enquiries',
  //   icon: 'message'
  // }, 
  // {
  //   text: 'FAQ',
  //   path: '/faq',
  //   icon: 'help'
  // },
  {
    text: 'Profile',
    path: '/profile',
    icon: 'user'
  }
// , 
//   {
//     text: 'Receipts',
//     path: '/receipts',
//     icon: 'folder'
//   }
// , 
//   {
//     text: 'TermsOfService',
//     path: '/terms-of-service',
//     icon: 'folder'
//   }
// , 
//   {
//     text: 'Supplimentary',
//     path: '/supplimentary',
//     icon: 'folder'
//   }, 
//   {
//     text: 'LoanTopUp',
//     path: '/loan-top-up',
//     icon: 'folder'
//   }, 
//   {
//     text: 'PayOff',
//     path: '/pay-off',
//     icon: 'folder'
//   }
// , 
//   {
//     text: 'NewTraveler',
//     path: '/new-traveler',
//     icon: 'folder'
//   }
  
];